/**
 * RSS Feed Reader — subscribe to and read feeds in the browser
 *
 * Declares one web-accessible-resource group listing four explicit image files under
 * extension-icons/, matched to every http(s) origin with no `use_dynamic_url` — so each
 * is fetchable from any page at a fixed URL.
 *
 * All are images, so `probeImage` loads them with no CORS grant, surviving a restrictive
 * page CSP. A successful load is conclusive — these files are served only when the
 * extension is installed.
 *
 * Manifest verified against version 8.0.28.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pnjaodmkngahhkoihejjehlcdlnohgmp';

export const rssFeedReader: ExtensionDefinition = {
  id: ID,
  name: 'RSS Feed Reader',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 500_000,
  notes:
    'Four explicit image WAR under extension-icons/ on every http(s) origin, no dynamic ' +
    'URL. All load via <img> with no CORS grant, so detection is conclusive.',
  signals: [
    {
      id: 'war-subscribe-logo',
      kind: 'web-accessible-resource',
      description:
        'Load extension-icons/subscribe-logo@2x.png via <img> — a vendor-named brand ' +
        'image exposed to every origin; needs no CORS grant, so it works under a strict CSP.',
      weight: 1,
      run: () => probeImage(ID, 'extension-icons/subscribe-logo@2x.png'),
    },
    {
      id: 'war-icon-retina',
      kind: 'web-accessible-resource',
      description:
        'Load extension-icons/icon-retina.png via <img> — a second image path, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'extension-icons/icon-retina.png'),
    },
    {
      id: 'war-icon-48',
      kind: 'web-accessible-resource',
      description:
        'Load extension-icons/icon48x48.png via <img> — a third independent image path.',
      weight: 0.5,
      run: () => probeImage(ID, 'extension-icons/icon48x48.png'),
    },
  ],
};
